export default {
  "nav.spreadsheet": "Feuille USFans",
  "nav.reviews": "Avis",
  "nav.shipping": "Livraison",
  "nav.guides": "Guides",
  "nav.safety": "Sécurité",
  "nav.faq": "FAQ",
  "nav.cta": "Explorer la feuille",
  "nav.home": "Accueil",
  "nav.shoppingGuide": "Guide d'achat",

  "hero.eyebrow": "LE CENTRE DE RESSOURCES USFANS",
  "hero.h1": "Feuille USFans — trouvez, comparez et explorez les ressources USFans",
  "hero.subtitle": "Vous cherchez une façon plus claire d'explorer les feuilles USFans, les informations produits, les ressources des vendeurs, les guides de contrôle qualité et les informations de livraison ? USFansLink réunit des ressources USFans utiles dans un hub unique, organisé et facile à rechercher.",
  "hero.ctaPrimary": "Explorer la feuille USFans",
  "hero.ctaSecondary": "Lire le guide USFans",
  "hero.trust": "Ressource indépendante • Mise à jour régulièrement • Conçue pour faciliter vos recherches",
  "hero.cardBadge": "Feuille USFans",
  "hero.cardTitle": "Centre de ressources organisé",
  "hero.cardText": "Parcourez les catégories, comparez les guides et accédez directement aux produits dont vous avez besoin.",

  "buttons.usfans": "feuille usfans",
  "buttons.buyNow": "Acheter maintenant",

  "categories.title": "Parcourir par catégorie",
  "categories.subtitle": "Choisissez une catégorie ci-dessous et accédez directement aux produits dont vous avez besoin sur notre site principal.",
  "categories.placeholder": "Sélectionnez une catégorie",
  "categories.go": "Aller à la catégorie",

  "cat.shoes": "Chaussures",
  "cat.hoodies": "Sweats à capuche / Pulls",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements / Caleçons",
  "cat.jersey": "Maillot",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  "value.title": "Tout ce qu'il faut pour rechercher USFans au même endroit",
  "value.subtitle": "Des ressources organisées et pratiques pour vous aider à évaluer les informations avant de décider.",
  "value.card1.title": "Feuille USFans",
  "value.card1.text": "Explorez des ressources de feuilles organisées et apprenez à évaluer les informations avant de prendre des décisions.",
  "value.card2.title": "Avis USFans",
  "value.card2.text": "Comprenez les facteurs clés à vérifier lors de vos recherches sur USFans et les services associés.",
  "value.card3.title": "Informations de livraison",
  "value.card3.text": "Découvrez comment les coûts, les méthodes, les options de livraison et les frais éventuels peuvent varier.",
  "value.card4.title": "Ressources de contrôle qualité",
  "value.card4.text": "Comprenez les photos de contrôle qualité, les détails produits et ce que les acheteurs devraient vérifier.",
  "value.card5.title": "Centre de sécurité",
  "value.card5.text": "Apprenez à repérer les liens suspects, à protéger vos comptes et à évaluer les sites externes.",

  "featured.title": "Explorez la feuille USFans",
  "featured.text": "Utilisez notre ressource de feuille USFans comme point de départ pour vos recherches. Comparez les informations, explorez les guides associés et découvrez des ressources pratiques sans passer d'une page dispersée à l'autre.",
  "featured.cta": "Voir la feuille USFans",

  "review.title": "Avis USFans : que faut-il vérifier ?",
  "review.text": "Avant d'utiliser un service d'achat ou d'approvisionnement en ligne, il est important de vérifier la réputation, les informations disponibles, les options de livraison, les processus d'entrepôt, les pratiques de paiement et la sécurité du compte. Nos guides expliquent quoi rechercher pour décider en connaissance de cause.",
  "review.cta": "Lire le guide d'avis USFans",

  "shipping.title": "Guide des frais de livraison USFans",
  "shipping.text": "Les frais de livraison peuvent varier selon la destination, la taille du colis, le poids, le mode de livraison et d'autres facteurs. Apprenez à comparer les options de livraison et à comprendre les informations affichées avant de passer commande.",
  "shipping.cta": "Explorer le guide de livraison",

  "safety.title": "USFans est-il légitime ? Ce qu'il faut vérifier",
  "safety.text": "Vous cherchez « USFans legit » ? Ne vous fiez pas à un seul avis ou à une publication sur les réseaux. Apprenez à évaluer les URL, les pages de paiement, la sécurité du compte, les informations sur les vendeurs, les liens externes et les autres signaux de confiance.",
  "safety.cta": "Lire le guide de sécurité USFans",

  "article.title": "Dernier guide USFans",
  "article.text": "Notre guide original et détaillé de la feuille USFans couvre ce qu'elle est, comment l'utiliser, quoi vérifier avant d'acheter et les points de sécurité essentiels à garder en tête.",
  "article.cta": "Lire le guide complet",

  "final.title": "Prêt à explorer les ressources USFans ?",
  "final.text": "Commencez par la feuille USFans, explorez les derniers guides et utilisez les informations qui correspondent le mieux à vos besoins.",
  "final.ctaPrimary": "Explorer la feuille USFans",
  "final.ctaSecondary": "Visiter le site principal",

  "pillars.eyebrow": "Guides USFans",
  "pillars.title": "Guides principaux USFans",
  "pillars.subtitle": "Des guides originaux et détaillés sur la feuille USFans, la livraison, la sécurité, le contrôle qualité, les coupons et plus encore.",
  "pillars.readMore": "Lire la suite",

  "footer.tagline": "Un centre de ressources indépendant qui réunit des ressources USFans utiles en un seul endroit organisé.",
  "footer.disclosure": "Ressource d'information gérée de façon indépendante. Non affilié officiellement à USFans.",
  "footer.explore": "Explorer",
  "footer.resources": "Ressources",
  "footer.navHome": "Accueil",
  "footer.navGuide": "Guide de la feuille USFans",
  "footer.navCategories": "Catégories",
  "footer.rights": "Tous droits réservés."
};